import React from "react";
import { useEffect } from "react";
import { FormHeroSection } from "@tennr/frontend/sections/FormHeroSection";
import { BookFeaturesSection } from "@tennr/frontend/sections/BookFeaturesSection";
import { BookTestimonialsSection } from "@tennr/frontend/sections/BookTestimonialsSection";
import { BookCtaSection } from "@tennr/frontend/sections/BookCtaSection";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import "@tennr/style/index.css";
import "./BookPage.css";

const bgImage = "/img/book-demo-hero-bg.jpg";
const bgImageVert = "/img/book-demo-hero-bg-vert.jpg";

export const BookPage: React.FC = () => {
  useEffect(() => {
    const preload = (src?: string) => {
      if (!src) return;
      const img = new Image();
      img.src = src;
    };

    const isMobile = window.innerWidth <= 768 || window.matchMedia("(orientation: portrait)").matches;

    if (isMobile) {
      // Preload vertical/mobile images
      preload("/img/homepage-hero-bg-vert2.jpg");
      preload("/img/product-hero-bg-vert2.jpg");
      preload("/img/customer-stories-hero-bg-vert.jpg");
      preload("/img/about-us-hero-bg-vert.jpg");
      preload("/img/case-study-hero-bg-vert.jpg");
      preload("/img/book-demo-hero-bg-vert.jpg");
    } else {
      // Preload desktop images
      preload("/img/homepage-hero-bg.jpg");
      preload("/img/product-hero-bg.jpg");
      preload("/img/customer-stories-hero-bg.jpg");
      preload("/img/about-us-hero-bg.jpg");
      preload("/img/case-study-hero-bg.jpg");
      preload("/img/book-demo-hero-bg.jpg");
    }

    preload("/img/grain.png"); // always used
  }, []);

  return (
    <>
      <MetadataTags
        title="Book a Demo | Tennr"
        description="Find a time to see how Tennr can help you convert more patients and reduce denials with fewer resources."
        imageUrl="https://tennr.com/share_cards/sharecard.png"
      />
      <main className="book-page">
        <PageBackground bgImage={bgImage} bgImageVert={bgImageVert} />
        <FormHeroSection {...{
            heading: {
              title:"BOOK A DEMO",
              heading:"Lock in long-term operational success",
              className:"form-hero-title",
              body:"Are you ready to improve intake, impress referrers, and grow your business?",
              variant:"hero",
              width:550,
            },
            hubspotForm:{ 
              portalId: "23158831", 
              formId: "ad73a2c1-22c3-4737-baa5-1944023021d0",
              region : "na1"
            }
          }} />
        <BookFeaturesSection />
        <BookTestimonialsSection />
        <BookCtaSection />
      </main>
      <SiteFooter taglinePosition="left" bgImage="/img/footer-demo-bg.jpg" bgImageVert="/img/footer-demo-bg-vert.jpg" />
    </>
  );
};
